

















































import { Component, Vue, Watch } from "vue-property-decorator";
import MainNavbar from "./MainNavbar.vue";
import SwitchlangHeader from "./SwitchlangHeader.vue";
import ApplicationStore from "./ApplicationStore.vue";
import DropdownUser from "./DropdownUser.vue";
import SelectCompany from "./SelectCompany.vue";
import { MerchantId } from "@/helper/userHelper";
import Notification from "./Notification.vue";
import UserManual from "./UserManual.vue";
import { namespace } from "vuex-class";
import { LoadingStatusType } from "@/enums/enums";

const StoreSetting = namespace("Setting");

@Component({
  components: { MainNavbar, SwitchlangHeader, ApplicationStore, DropdownUser, SelectCompany, Notification, UserManual },
})
export default class Header extends Vue {
  private isConnectWithPeak: any = false;

  private scrollOver = false;
  private lastScrollTop = 0;

  @StoreSetting.Getter
  private getSettingConnectPeakModel!: any;

  mounted() {
    window.addEventListener("scroll", this.HandleScroll);
  }
  public HandleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop > this.lastScrollTop) {
      // downscroll code
      this.scrollOver = false;
    } else if (currentScrollTop < this.lastScrollTop) {
      // upscroll code
      this.scrollOver = window.scrollY > 110;
    }
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  created() {
    if (this.getSettingConnectPeakModel) {
      this.isConnectWithPeak = this.getSettingConnectPeakModel.isPeakTaxConnected;
    }
  }

  public ToHomePage() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
  }
}
